<template>
    <v-content>
        <v-breadcrumbs :items="breadcrumbsItems" large></v-breadcrumbs>
        <v-row>
           
            <v-col cols="12"
                   sm="6"
                   md="3"
                   xl="2"
                   v-for="title in snackbar.departmentList"
                   v-bind:key="title.link"
                   class="viewCard">



                <router-link :to="'/company/'+ usersData.companyID + '/department/'+ title.id + '/branches/'+ title.id">
                    <v-card :elevation="10"
                            class="main-color text-center"
                            height="120"
                            width="300">
                        <v-list-item three-line link>
                            <v-list-item-content>
                                <v-list-item-title class="white--text subtitle-1 mt-1 pa-4">
                                    {{title.name}}
                                </v-list-item-title>
                                <v-list-item-subtitle class="white--text header-6 mt-1">
                                    {{$t('total')}} {{$t('branch')}}: {{title.count}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </router-link>
            </v-col>
        </v-row>
    </v-content>
</template>

<script>
    /*import CompanyDashboardMenu from "./CompanyDashboardMenu";*/
    import axios from "axios";
    import {mapGetters} from "vuex";

    export default {
        name: "CompanyDepartmentList",
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            breadcrumbsItems() {
                return [
                    {
                        text: this.$t('dashboard'),
                        disabled: false,
                        to: "",
                        exact: true
                    },
                    {
                        text: this.$t('department'),
                        disabled: true,
                        to: "",
                        exact: true
                    },
                ]
            }
        },
        data() {
            return {
                snackbar: {
                    formModal: false,
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    drawer: null,
                    drawerRight: null,
                    right: false,
                    departmentList: [

                    ],
                    
                },
            }
        },
        methods: {
            loadBreadCrumbs(){
                this.snackbar.breadcrumbsItems[0].to = this.usersData.dashBoard
            },
            clickEvent(route) {
                this.$router.push({name: route})
            },
            async loadDepartmentList() {
               
                const loadDepartmentList = await axios.get(
                    "Department/CompanyDepartmentCount", { CompanyID: parseInt(this.usersData.companyID)
                });
              
                this.snackbar.departmentList = loadDepartmentList.data.list;
            }
        },
        mounted() {
            this.loadDepartmentList()
            this.loadBreadCrumbs()
        },
        components: {
            /* 'menu-list': CompanyDashboardMenu,*/
            /*// eslint-disable-next-line vue/no-unused-components
            'CompanyForm': () => import(/!* webpackChunkName: "CompanyForm" *!/ '../company/airDestination/CompanyForm'),
            // eslint-disable-next-line vue/no-unused-components
            'SectionsForm': () => import(/!* webpackChunkName: "SectionsForm" *!/ '../company/Sections/SectionsForm'),
            // eslint-disable-next-line vue/no-unused-components
            'PeriodicBudgetForm': () => import(/!* webpackChunkName: "PeriodicBudgetForm" *!/ '../company/PeriodicBudget/PeriodicBudgetForm'),
            // eslint-disable-next-line vue/no-unused-components
            'CustomerForm': () => import(/!* webpackChunkName: "CustomerForm" *!/ '../company/customer/CustomerForm')*/
        }
    }
</script>

<style scoped lang="scss">
    .options {
        border: 2px solid white;
    }

</style>
